/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Done-all': {
    width: 28,
    height: 17,
    viewBox: '0 0 28 17',
    data: '<path pid="0" d="M20.998 2.167L19.353.522l-7.396 7.396 1.645 1.645 7.396-7.396zM25.945.522L13.602 12.865 8.725 8 7.08 9.645l6.522 6.522 14-14L25.945.522zM.477 9.645l6.521 6.522 1.645-1.645L2.133 8 .477 9.645z" _fill="#9BC225"/>'
  }
})
